import { useMutation } from 'react-query'
import { userUseCase } from '../../factories'

const useUpdateUser = () => useMutation(userUseCase.updateUser)

export default useUpdateUser
